module.exports = __webpack_public_path__ + "images/vector/app/web/src/assets/close orange icon-4b9889e6.svg";


//////////////////
// WEBPACK FOOTER
// ./app/web/src/assets/close orange icon.svg
// module id = ./app/web/src/assets/close orange icon.svg
// module chunks = 0